import { render } from "./PantryPRFoodPage.vue?vue&type=template&id=661ec49e&ts=true"
import script from "./PantryPRFoodPage.vue?vue&type=script&lang=ts"
export * from "./PantryPRFoodPage.vue?vue&type=script&lang=ts"

import "./PantryPRFoodPage.vue?vue&type=style&index=0&id=661ec49e&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__